import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      // Keep data in memory for 30 minutes so navigating back to a page
      // doesn't show loading skeletons when the data is still fresh enough.
      gcTime: 30 * 60_000,
    },
    mutations: {
      retry: false,
    },
  },
});
